export const DENIED_DETAIL = 'L’accès à la position a été refusé par le navigateur ou le système. Vérifiez les autorisations du site et du téléphone.';
export const GEO_ACK_KEY = 'dsp_geo_notice_ack';
export const geoAcknowledged = () => { try { return localStorage.getItem(GEO_ACK_KEY) === '1'; } catch { return false; } };
export const acknowledgeGeo = () => { try { localStorage.setItem(GEO_ACK_KEY, '1'); } catch { /* La notice restera disponible. */ } };

// Une seule lecture au pointage explicite. Aucun watchPosition, suivi ou nouvel essai automatique.
export const readPosition = () => {
  const unavailable = detail => ({ payload: { status: 'indisponible', detail }, browserCode: null });
  if (!navigator.geolocation) return Promise.resolve(unavailable('Localisation non prise en charge par ce navigateur'));
  if (!window.isSecureContext) return Promise.resolve(unavailable('Connexion non sécurisée : localisation impossible'));
  return new Promise(resolve => {
    const timer = window.setTimeout(() => resolve(unavailable('Délai dépassé : aucune réponse de localisation reçue')), 12000);
    const complete = result => { window.clearTimeout(timer); resolve(result); };
    try {
      navigator.geolocation.getCurrentPosition(
        p => complete({ payload: { status: 'capturee', lat: p.coords.latitude, lon: p.coords.longitude,
          accuracy_m: p.coords.accuracy, captured_at: new Date(p.timestamp).toISOString() }, browserCode: null }),
        e => complete({ browserCode: e.code, payload: e.code === 1
          ? { status: 'permission_refusee', detail: DENIED_DETAIL }
          : { status: 'indisponible', detail: e.code === 3 ? 'Délai dépassé (10 s) : position non obtenue à temps' : 'Position indisponible (GPS/réseau)' } }),
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
    } catch { complete(unavailable('La demande de position n’a pas pu être exécutée par le navigateur')); }
  });
};

const journalKey = userId => `dsp_geo_diagnostic:${userId}`;
export const loadGeoJournal = userId => {
  try {
    const values = JSON.parse(sessionStorage.getItem(journalKey(userId)) || '{}');
    return Object.fromEntries(Object.entries(values).filter(([, v]) => Date.now() - v.at < 86400000));
  } catch { return {}; }
};
// Diagnostic de cette session, sans coordonnées, sans agent utilisateur ni géolocalisation supplémentaire.
export const saveGeoJournal = (userId, journal) => {
  try { sessionStorage.setItem(journalKey(userId), JSON.stringify(journal)); } catch { /* Le retour à l'écran reste disponible. */ }
};